import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  arts: undefined,
  artDetail: {},
  isuploading: false,
  buyOriginalType: undefined,
  isLoading: false,
  isSendingDetail: false,
  isArtListLoading: false,
};

const artSlice = createSlice({
  name: "art",
  initialState,
  reducers: {
    setIsArtListLoading(state, action) {
      state.isArtListLoading = action.payload.isArtListLoading;
    },
    setIsSendingDetail(state, action) {
      state.isSendingDetail = action.payload.isSendingDetail;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload.isLoading;
    },
    setBuyOriginalType(state, action) {
      state.buyOriginalType = action.payload.buyOriginalType;
    },
    setIsUploading(state, action) {
      state.isuploading = action.payload.isuploading;
    },
    getAllarts(state, action) {
      state.arts = action.payload.arts;
    },
    getArtDetails(state, action) {
      state.artDetail = action.payload.artDetail;
    },
  },
});

export const {
  getAllarts,
  getArtDetails,
  setIsUploading,
  setBuyOriginalType,
  setIsLoading,
  setIsSendingDetail,
  setIsArtListLoading,
} = artSlice.actions;
export const artSliceReducer = artSlice.reducer;
